<!--
  LINE passcode / lock screen preview. A dark screen (the theme wallpaper under
  a heavy scrim so the glow reads) with "Enter passcode", the four themed dots
  (Everest = kawaii mountains) and the numeric keypad, inside the iPhone frame.
-->
<div class="line-stage">
  <div class="phone" [style.--fg]="fg" [style.--fg-dim]="fgDim" [style.--bg]="bg" [style.--scrim]="scrim">
    <div class="screen">
      <div class="wallpaper" [style.background-image]="background ? 'url(' + background + ')' : null"></div>

      <!-- Sakura two-zone: a pink block over the top ~52% (behind the title +
           blossom dots); the number pad sits on the pale screen below. -->
      <div class="lk-topzone" *ngIf="twoZone" [style.background]="topZone"></div>

      <div class="statusbar">
        <span class="time">9:41</span>
        <span class="status-right" aria-hidden="true"></span>
      </div>

      <div class="lock">
        <div class="lk-title">Enter Passcode</div>
        <div class="lk-sub">Please enter a passcode</div>

        <div class="lk-dots">
          <app-line-passcode *ngFor="let d of dots" class="lk-dot"
                             [on]="d.on" [variant]="variant" [seed]="d.seed"
                             [color]="d.color" [offColor]="offColor"></app-line-passcode>
        </div>

        <div class="lk-pad" [style.--pad]="padColor || null">
          <ng-container *ngFor="let k of keys">
            <span class="lk-key" [class.empty]="k === ''">
              <ng-container *ngIf="k !== 'del' && k !== ''">{{ k }}</ng-container>
              <svg *ngIf="k === 'del'" class="lk-del" viewBox="0 0 26 20" aria-hidden="true">
                <path d="M8 2h15a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8L1 10z" fill="none" stroke-width="1.6"></path>
                <line x1="12" y1="7" x2="19" y2="13" stroke-width="1.6"></line>
                <line x1="19" y1="7" x2="12" y2="13" stroke-width="1.6"></line>
              </svg>
            </span>
          </ng-container>
        </div>
      </div>
    </div>

    <img class="frame" [src]="frameSrc" alt="" aria-hidden="true">
  </div>
</div>
